import React, { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { Navigate } from 'react-router-dom';
import Axios from 'axios';
import config from './config';

const ProtectedRoute = ({ children, requiredPermissions = [], requireAll = false }) => {
    const [cookies] = useCookies(['userId', 'idEmpresa']);
    const [userPermissions, setUserPermissions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [hasAccess, setHasAccess] = useState(false);

    useEffect(() => {
        const checkPermissions = async () => {
            if (!cookies.userId || !cookies.idEmpresa) {
                setLoading(false);
                return;
            }

            try {
                const response = await Axios.get(`${config.API_URL}/getPermisosModulos`, {
                    params: {
                        userId: cookies.userId,
                        empresaId: cookies.idEmpresa
                    }
                });

                const permissions = response.data.map(modulo => modulo.Modulo);
                setUserPermissions(permissions);

                // Verificar si el usuario tiene los permisos necesarios
                let access = false;

                if (requiredPermissions.length === 0) {
                    // Si no se requieren permisos específicos, permitir acceso
                    access = true;
                } else if (requireAll) {
                    // Verificar que tenga TODOS los permisos requeridos
                    access = requiredPermissions.every(permission => permissions.includes(permission));
                } else {
                    // Verificar que tenga AL MENOS UNO de los permisos requeridos
                    access = requiredPermissions.some(permission => permissions.includes(permission));
                }

                setHasAccess(access);
            } catch (error) {
                console.error("Error al verificar permisos:", error);
                setHasAccess(false);
            } finally {
                setLoading(false);
            }
        };

        checkPermissions();
    }, [cookies.userId, cookies.idEmpresa, requiredPermissions, requireAll]);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Cargando...</span>
                </div>
            </div>
        );
    }

    if (!cookies.userId) {
        return <Navigate to="/login" replace />;
    }

    if (!cookies.idEmpresa) {
        return <Navigate to="/Prehome" replace />;
    }

    if (!hasAccess) {
        return (
            <div className="container-fluid">
                <div className="row justify-content-center">
                    <div className="col-lg-6">
                        <div className="text-center mt-5">
                            <div className="error mx-auto" data-text="403">403</div>
                            <p className="lead text-gray-800 mb-5">Acceso Denegado</p>
                            <p className="text-gray-500 mb-0">
                                No tienes permisos para acceder a esta sección del sistema.
                            </p>
                            <p className="text-gray-500 mb-4">
                                Contacta al administrador si consideras que deberías tener acceso.
                            </p>
                            <a href="/Prehome" className="btn btn-primary">
                                <i className="fas fa-arrow-left mr-2"></i>
                                Volver al inicio
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return children;
};

export default ProtectedRoute;
